











































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Page as PageInterface } from "../../services/settings/entities/page.interface";
import privileges from "../../utils/privileges";
import constants from "../../config/constants";

@Component
export default class Page extends Vue {
  @Prop() page!: PageInterface;

  status = this.page.pageStatus == "ACTIVE" ? true : false;
  privilegeName = constants.PRIVILEGE_NAME;
  privilegeType = constants.PRIVILEGE_TYPE;

  private checkPrivilege(name: string, type: string): boolean {
    return privileges.checkPrivilege(name, type);
  }

  @Watch("status")
  private changeStatus(): void {
    this.$store.dispatch("settings/updatePage", {
      pageId: this.page.pageID,
      status: this.status ? "ACTIVE" : "INACTIVE"
    });
  }
}
